import lodash from 'lodash'

import { IOrderEntryAddress } from '../types'
import relevantAddressProps from './relevantAddressProps'

export function fixAddress(address: object): IOrderEntryAddress {
  return lodash.pick(address, relevantAddressProps) as IOrderEntryAddress
}
